import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_VILLAGE_BY_COMMUNE } from "../Schema/SelectSchema";

export const useGetVillageByCommune = ({ communeSangkatId }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState();

  const { refetch } = useQuery(GET_VILLAGE_BY_COMMUNE, {
    variables: {
      communeSangkatId: communeSangkatId,
    },
    onCompleted: ({ getVillageByCommune }) => {
     
      setTableData(getVillageByCommune || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { tableData, loading, refetch };
};
